import {
  AccountBookFilled,
  AppstoreOutlined,
  ArrowLeftOutlined,
  BellFilled,
  CalendarFilled,
  CalendarTwoTone,
  CloseCircleOutlined,
  CloseOutlined,
  CheckCircleOutlined,
  CheckCircleTwoTone,
  CheckCircleFilled,
  DeleteFilled,
  DownOutlined,
  EditOutlined,
  EllipsisOutlined,
  ExclamationCircleOutlined,
  ExclamationCircleTwoTone,
  FundFilled,
  FileImageOutlined,
  InfoCircleOutlined,
  InfoCircleTwoTone,
  InfoCircleFilled,
  HomeFilled,
  LeftOutlined,
  LoadingOutlined,
  MailOutlined,
  MinusCircleOutlined,
  MinusCircleTwoTone,
  MoneyCollectFilled,
  MoneyCollectTwoTone,
  PayCircleFilled,
  PlusOutlined,
  QuestionCircleTwoTone,
  RightOutlined,
  SearchOutlined,
  SettingFilled,
  SettingOutlined,
  TagFilled,
  UpOutlined,
  UploadOutlined,
  UserOutlined,
  CopyOutlined,
  PropertySafetyOutlined,
} from '@ant-design/icons'
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon'
import { RefAttributes } from 'react'

interface IconType {
  [x: string]: any &
    Pick<
      AntdIconProps,
      | 'max'
      | 'required'
      | 'type'
      | 'data'
      | 'default'
      | 'high'
      | 'low'
      | 'key'
      | 'id'
      | 'media'
      | 'height'
      | 'width'
      | 'start'
      | 'open'
      | 'name'
      | 'color'
      | 'content'
      | 'rotate'
      | 'translate'
      | 'value'
      | 'hidden'
      | 'cite'
      | 'form'
      | 'label'
      | 'slot'
      | 'span'
      | 'style'
      | 'summary'
      | 'title'
      | 'dir'
      | 'pattern'
      | 'acceptCharset'
      | 'action'
      | 'method'
      | 'noValidate'
      | 'target'
      | 'accessKey'
      | 'draggable'
      | 'lang'
      | 'className'
      | 'prefix'
      | 'role'
      | 'children'
      | 'contentEditable'
      | 'inputMode'
      | 'nonce'
      | 'tabIndex'
      | 'async'
      | 'disabled'
      | 'multiple'
      | 'size'
      | 'manifest'
      | 'wrap'
      | 'accept'
      | 'allowFullScreen'
      | 'allowTransparency'
      | 'alt'
      | 'as'
      | 'autoComplete'
      | 'autoFocus'
      | 'autoPlay'
      | 'capture'
      | 'cellPadding'
      | 'cellSpacing'
      | 'charSet'
      | 'challenge'
      | 'checked'
      | 'classID'
      | 'cols'
      | 'colSpan'
      | 'controls'
      | 'coords'
      | 'crossOrigin'
      | 'dateTime'
      | 'defer'
      | 'download'
      | 'encType'
      | 'formAction'
      | 'formEncType'
      | 'formMethod'
      | 'formNoValidate'
      | 'formTarget'
      | 'frameBorder'
      | 'headers'
      | 'href'
      | 'hrefLang'
      | 'htmlFor'
      | 'httpEquiv'
      | 'integrity'
      | 'keyParams'
      | 'keyType'
      | 'kind'
      | 'list'
      | 'loop'
      | 'marginHeight'
      | 'marginWidth'
      | 'maxLength'
      | 'mediaGroup'
      | 'min'
      | 'minLength'
      | 'muted'
      | 'optimum'
      | 'defaultChecked'
      | 'defaultValue'
      | 'suppressContentEditableWarning'
      | 'suppressHydrationWarning'
      | 'contextMenu'
      | 'placeholder'
      | 'spellCheck'
      | 'radioGroup'
      | 'about'
      | 'datatype'
      | 'inlist'
      | 'property'
      | 'resource'
      | 'typeof'
      | 'vocab'
      | 'autoCapitalize'
      | 'autoCorrect'
      | 'autoSave'
      | 'itemProp'
      | 'itemScope'
      | 'itemType'
      | 'itemID'
      | 'itemRef'
      | 'results'
      | 'security'
      | 'unselectable'
      | 'is'
      | 'aria-activedescendant'
      | 'aria-atomic'
      | 'aria-autocomplete'
      | 'aria-busy'
      | 'aria-checked'
      | 'aria-colcount'
      | 'aria-colindex'
      | 'aria-colspan'
      | 'aria-controls'
      | 'aria-current'
      | 'aria-describedby'
      | 'aria-details'
      | 'aria-disabled'
      | 'aria-dropeffect'
      | 'aria-errormessage'
      | 'aria-expanded'
      | 'aria-flowto'
      | 'aria-grabbed'
      | 'aria-haspopup'
      | 'aria-hidden'
      | 'aria-invalid'
      | 'aria-keyshortcuts'
      | 'aria-label'
      | 'aria-labelledby'
      | 'aria-level'
      | 'aria-live'
      | 'aria-modal'
      | 'aria-multiline'
      | 'aria-multiselectable'
      | 'aria-orientation'
      | 'aria-owns'
      | 'aria-placeholder'
      | 'aria-posinset'
      | 'aria-pressed'
      | 'aria-readonly'
      | 'aria-relevant'
      | 'aria-required'
      | 'aria-roledescription'
      | 'aria-rowcount'
      | 'aria-rowindex'
      | 'aria-rowspan'
      | 'aria-selected'
      | 'aria-setsize'
      | 'aria-sort'
      | 'aria-valuemax'
      | 'aria-valuemin'
      | 'aria-valuenow'
      | 'aria-valuetext'
      | 'playsInline'
      | 'poster'
      | 'preload'
      | 'readOnly'
      | 'rel'
      | 'reversed'
      | 'rows'
      | 'rowSpan'
      | 'sandbox'
      | 'scope'
      | 'scoped'
      | 'scrolling'
      | 'seamless'
      | 'selected'
      | 'shape'
      | 'sizes'
      | 'src'
      | 'srcDoc'
      | 'srcLang'
      | 'srcSet'
      | 'step'
      | 'useMap'
      | 'wmode'
      | 'dangerouslySetInnerHTML'
      | 'onCopy'
      | 'onCopyCapture'
      | 'onCut'
      | 'onCutCapture'
      | 'onPaste'
      | 'onPasteCapture'
      | 'onCompositionEnd'
      | 'onCompositionEndCapture'
      | 'onCompositionStart'
      | 'onCompositionStartCapture'
      | 'onCompositionUpdate'
      | 'onCompositionUpdateCapture'
      | 'onFocus'
      | 'onFocusCapture'
      | 'onBlur'
      | 'onBlurCapture'
      | 'onChange'
      | 'onChangeCapture'
      | 'onBeforeInput'
      | 'onBeforeInputCapture'
      | 'onInput'
      | 'onInputCapture'
      | 'onReset'
      | 'onResetCapture'
      | 'onSubmit'
      | 'onSubmitCapture'
      | 'onInvalid'
      | 'onInvalidCapture'
      | 'onLoad'
      | 'onLoadCapture'
      | 'onError'
      | 'onErrorCapture'
      | 'onKeyDown'
      | 'onKeyDownCapture'
      | 'onKeyPress'
      | 'onKeyPressCapture'
      | 'onKeyUp'
      | 'onKeyUpCapture'
      | 'onAbort'
      | 'onAbortCapture'
      | 'onCanPlay'
      | 'onCanPlayCapture'
      | 'onCanPlayThrough'
      | 'onCanPlayThroughCapture'
      | 'onDurationChange'
      | 'onDurationChangeCapture'
      | 'onEmptied'
      | 'onEmptiedCapture'
      | 'onEncrypted'
      | 'onEncryptedCapture'
      | 'onEnded'
      | 'onEndedCapture'
      | 'onLoadedData'
      | 'onLoadedDataCapture'
      | 'onLoadedMetadata'
      | 'onLoadedMetadataCapture'
      | 'onLoadStart'
      | 'onLoadStartCapture'
      | 'onPause'
      | 'onPauseCapture'
      | 'onPlay'
      | 'onPlayCapture'
      | 'onPlaying'
      | 'onPlayingCapture'
      | 'onProgress'
      | 'onProgressCapture'
      | 'onRateChange'
      | 'onRateChangeCapture'
      | 'onSeeked'
      | 'onSeekedCapture'
      | 'onSeeking'
      | 'onSeekingCapture'
      | 'onStalled'
      | 'onStalledCapture'
      | 'onSuspend'
      | 'onSuspendCapture'
      | 'onTimeUpdate'
      | 'onTimeUpdateCapture'
      | 'onVolumeChange'
      | 'onVolumeChangeCapture'
      | 'onWaiting'
      | 'onWaitingCapture'
      | 'onAuxClick'
      | 'onAuxClickCapture'
      | 'onClick'
      | 'onClickCapture'
      | 'onContextMenu'
      | 'onContextMenuCapture'
      | 'onDoubleClick'
      | 'onDoubleClickCapture'
      | 'onDrag'
      | 'onDragCapture'
      | 'onDragEnd'
      | 'onDragEndCapture'
      | 'onDragEnter'
      | 'onDragEnterCapture'
      | 'onDragExit'
      | 'onDragExitCapture'
      | 'onDragLeave'
      | 'onDragLeaveCapture'
      | 'onDragOver'
      | 'onDragOverCapture'
      | 'onDragStart'
      | 'onDragStartCapture'
      | 'onDrop'
      | 'onDropCapture'
      | 'onMouseDown'
      | 'onMouseDownCapture'
      | 'onMouseEnter'
      | 'onMouseLeave'
      | 'onMouseMove'
      | 'onMouseMoveCapture'
      | 'onMouseOut'
      | 'onMouseOutCapture'
      | 'onMouseOver'
      | 'onMouseOverCapture'
      | 'onMouseUp'
      | 'onMouseUpCapture'
      | 'onSelect'
      | 'onSelectCapture'
      | 'onTouchCancel'
      | 'onTouchCancelCapture'
      | 'onTouchEnd'
      | 'onTouchEndCapture'
      | 'onTouchMove'
      | 'onTouchMoveCapture'
      | 'onTouchStart'
      | 'onTouchStartCapture'
      | 'onPointerDown'
      | 'onPointerDownCapture'
      | 'onPointerMove'
      | 'onPointerMoveCapture'
      | 'onPointerUp'
      | 'onPointerUpCapture'
      | 'onPointerCancel'
      | 'onPointerCancelCapture'
      | 'onPointerEnter'
      | 'onPointerEnterCapture'
      | 'onPointerLeave'
      | 'onPointerLeaveCapture'
      | 'onPointerOver'
      | 'onPointerOverCapture'
      | 'onPointerOut'
      | 'onPointerOutCapture'
      | 'onGotPointerCapture'
      | 'onGotPointerCaptureCapture'
      | 'onLostPointerCapture'
      | 'onLostPointerCaptureCapture'
      | 'onScroll'
      | 'onScrollCapture'
      | 'onWheel'
      | 'onWheelCapture'
      | 'onAnimationStart'
      | 'onAnimationStartCapture'
      | 'onAnimationEnd'
      | 'onAnimationEndCapture'
      | 'onAnimationIteration'
      | 'onAnimationIterationCapture'
      | 'onTransitionEnd'
      | 'onTransitionEndCapture'
      | 'spin'
      | 'twoToneColor'
    > &
    RefAttributes<HTMLSpanElement>
  Icon: any &
    Pick<
      AntdIconProps,
      | 'id'
      | 'form'
      | 'data'
      | 'value'
      | 'type'
      | 'title'
      | 'cite'
      | 'label'
      | 'slot'
      | 'span'
      | 'style'
      | 'summary'
      | 'pattern'
      | 'children'
      | 'size'
      | 'href'
      | 'onClick'
      | 'className'
      | 'defaultChecked'
      | 'defaultValue'
      | 'suppressContentEditableWarning'
      | 'suppressHydrationWarning'
      | 'accessKey'
      | 'autoFocus'
      | 'contentEditable'
      | 'contextMenu'
      | 'dir'
      | 'draggable'
      | 'hidden'
      | 'lang'
      | 'nonce'
      | 'placeholder'
      | 'spellCheck'
      | 'tabIndex'
      | 'translate'
      | 'radioGroup'
      | 'role'
      | 'about'
      | 'content'
      | 'datatype'
      | 'inlist'
      | 'prefix'
      | 'property'
      | 'rel'
      | 'resource'
      | 'typeof'
      | 'vocab'
      | 'autoCapitalize'
      | 'autoCorrect'
      | 'autoSave'
      | 'color'
      | 'itemProp'
      | 'itemScope'
      | 'itemType'
      | 'itemID'
      | 'itemRef'
      | 'results'
      | 'security'
      | 'unselectable'
      | 'inputMode'
      | 'is'
      | 'aria-activedescendant'
      | 'aria-atomic'
      | 'aria-autocomplete'
      | 'aria-busy'
      | 'aria-checked'
      | 'aria-colcount'
      | 'aria-colindex'
      | 'aria-colspan'
      | 'aria-controls'
      | 'aria-current'
      | 'aria-describedby'
      | 'aria-details'
      | 'aria-disabled'
      | 'aria-dropeffect'
      | 'aria-errormessage'
      | 'aria-expanded'
      | 'aria-flowto'
      | 'aria-grabbed'
      | 'aria-haspopup'
      | 'aria-hidden'
      | 'aria-invalid'
      | 'aria-keyshortcuts'
      | 'aria-label'
      | 'aria-labelledby'
      | 'aria-level'
      | 'aria-live'
      | 'aria-modal'
      | 'aria-multiline'
      | 'aria-multiselectable'
      | 'aria-orientation'
      | 'aria-owns'
      | 'aria-placeholder'
      | 'aria-posinset'
      | 'aria-pressed'
      | 'aria-readonly'
      | 'aria-relevant'
      | 'aria-required'
      | 'aria-roledescription'
      | 'aria-rowcount'
      | 'aria-rowindex'
      | 'aria-rowspan'
      | 'aria-selected'
      | 'aria-setsize'
      | 'aria-sort'
      | 'aria-valuemax'
      | 'aria-valuemin'
      | 'aria-valuenow'
      | 'aria-valuetext'
      | 'dangerouslySetInnerHTML'
      | 'onCopy'
      | 'onCopyCapture'
      | 'onCut'
      | 'onCutCapture'
      | 'onPaste'
      | 'onPasteCapture'
      | 'onCompositionEnd'
      | 'onCompositionEndCapture'
      | 'onCompositionStart'
      | 'onCompositionStartCapture'
      | 'onCompositionUpdate'
      | 'onCompositionUpdateCapture'
      | 'onFocus'
      | 'onFocusCapture'
      | 'onBlur'
      | 'onBlurCapture'
      | 'onChange'
      | 'onChangeCapture'
      | 'onBeforeInput'
      | 'onBeforeInputCapture'
      | 'onInput'
      | 'onInputCapture'
      | 'onReset'
      | 'onResetCapture'
      | 'onSubmit'
      | 'onSubmitCapture'
      | 'onInvalid'
      | 'onInvalidCapture'
      | 'onLoad'
      | 'onLoadCapture'
      | 'onError'
      | 'onErrorCapture'
      | 'onKeyDown'
      | 'onKeyDownCapture'
      | 'onKeyPress'
      | 'onKeyPressCapture'
      | 'onKeyUp'
      | 'onKeyUpCapture'
      | 'onAbort'
      | 'onAbortCapture'
      | 'onCanPlay'
      | 'onCanPlayCapture'
      | 'onCanPlayThrough'
      | 'onCanPlayThroughCapture'
      | 'onDurationChange'
      | 'onDurationChangeCapture'
      | 'onEmptied'
      | 'onEmptiedCapture'
      | 'onEncrypted'
      | 'onEncryptedCapture'
      | 'onEnded'
      | 'onEndedCapture'
      | 'onLoadedData'
      | 'onLoadedDataCapture'
      | 'onLoadedMetadata'
      | 'onLoadedMetadataCapture'
      | 'onLoadStart'
      | 'onLoadStartCapture'
      | 'onPause'
      | 'onPauseCapture'
      | 'onPlay'
      | 'onPlayCapture'
      | 'onPlaying'
      | 'onPlayingCapture'
      | 'onProgress'
      | 'onProgressCapture'
      | 'onRateChange'
      | 'onRateChangeCapture'
      | 'onSeeked'
      | 'onSeekedCapture'
      | 'onSeeking'
      | 'onSeekingCapture'
      | 'onStalled'
      | 'onStalledCapture'
      | 'onSuspend'
      | 'onSuspendCapture'
      | 'onTimeUpdate'
      | 'onTimeUpdateCapture'
      | 'onVolumeChange'
      | 'onVolumeChangeCapture'
      | 'onWaiting'
      | 'onWaitingCapture'
      | 'onAuxClick'
      | 'onAuxClickCapture'
      | 'onClickCapture'
      | 'onContextMenu'
      | 'onContextMenuCapture'
      | 'onDoubleClick'
      | 'onDoubleClickCapture'
      | 'onDrag'
      | 'onDragCapture'
      | 'onDragEnd'
      | 'onDragEndCapture'
      | 'onDragEnter'
      | 'onDragEnterCapture'
      | 'onDragExit'
      | 'onDragExitCapture'
      | 'onDragLeave'
      | 'onDragLeaveCapture'
      | 'onDragOver'
      | 'onDragOverCapture'
      | 'onDragStart'
      | 'onDragStartCapture'
      | 'onDrop'
      | 'onDropCapture'
      | 'onMouseDown'
      | 'onMouseDownCapture'
      | 'onMouseEnter'
      | 'onMouseLeave'
      | 'onMouseMove'
      | 'onMouseMoveCapture'
      | 'onMouseOut'
      | 'onMouseOutCapture'
      | 'onMouseOver'
      | 'onMouseOverCapture'
      | 'onMouseUp'
      | 'onMouseUpCapture'
      | 'onSelect'
      | 'onSelectCapture'
      | 'onTouchCancel'
      | 'onTouchCancelCapture'
      | 'onTouchEnd'
      | 'onTouchEndCapture'
      | 'onTouchMove'
      | 'onTouchMoveCapture'
      | 'onTouchStart'
      | 'onTouchStartCapture'
      | 'onPointerDown'
      | 'onPointerDownCapture'
      | 'onPointerMove'
      | 'onPointerMoveCapture'
      | 'onPointerUp'
      | 'onPointerUpCapture'
      | 'onPointerCancel'
      | 'onPointerCancelCapture'
      | 'onPointerEnter'
      | 'onPointerEnterCapture'
      | 'onPointerLeave'
      | 'onPointerLeaveCapture'
      | 'onPointerOver'
      | 'onPointerOverCapture'
      | 'onPointerOut'
      | 'onPointerOutCapture'
      | 'onGotPointerCapture'
      | 'onGotPointerCaptureCapture'
      | 'onLostPointerCapture'
      | 'onLostPointerCaptureCapture'
      | 'onScroll'
      | 'onScrollCapture'
      | 'onWheel'
      | 'onWheelCapture'
      | 'onAnimationStart'
      | 'onAnimationStartCapture'
      | 'onAnimationEnd'
      | 'onAnimationEndCapture'
      | 'onAnimationIteration'
      | 'onAnimationIterationCapture'
      | 'onTransitionEnd'
      | 'onTransitionEndCapture'
      | 'open'
      | 'width'
      | 'disabled'
      | 'download'
      | 'hrefLang'
      | 'media'
      | 'target'
      | 'formAction'
      | 'formEncType'
      | 'formMethod'
      | 'formNoValidate'
      | 'formTarget'
      | 'name'
      | 'list'
      | 'step'
      | 'shape'
      | 'default'
      | 'autoComplete'
      | 'acceptCharset'
      | 'action'
      | 'encType'
      | 'method'
      | 'noValidate'
      | 'required'
      | 'htmlFor'
      | 'accept'
      | 'alt'
      | 'capture'
      | 'checked'
      | 'crossOrigin'
      | 'height'
      | 'max'
      | 'maxLength'
      | 'min'
      | 'minLength'
      | 'multiple'
      | 'readOnly'
      | 'src'
      | 'high'
      | 'low'
      | 'key'
      | 'start'
      | 'rotate'
      | 'async'
      | 'manifest'
      | 'wrap'
      | 'allowFullScreen'
      | 'allowTransparency'
      | 'as'
      | 'autoPlay'
      | 'cellPadding'
      | 'cellSpacing'
      | 'charSet'
      | 'challenge'
      | 'classID'
      | 'cols'
      | 'colSpan'
      | 'controls'
      | 'coords'
      | 'dateTime'
      | 'defer'
      | 'frameBorder'
      | 'headers'
      | 'httpEquiv'
      | 'integrity'
      | 'keyParams'
      | 'keyType'
      | 'kind'
      | 'loop'
      | 'marginHeight'
      | 'marginWidth'
      | 'mediaGroup'
      | 'muted'
      | 'optimum'
      | 'playsInline'
      | 'poster'
      | 'preload'
      | 'reversed'
      | 'rows'
      | 'rowSpan'
      | 'sandbox'
      | 'scope'
      | 'scoped'
      | 'scrolling'
      | 'seamless'
      | 'selected'
      | 'sizes'
      | 'srcDoc'
      | 'srcLang'
      | 'srcSet'
      | 'useMap'
      | 'wmode'
      | 'spin'
      | 'twoToneColor'
    > &
    RefAttributes<HTMLSpanElement>
  AccountBookFilled: typeof AccountBookFilled
  AppstoreOutlined: typeof AppstoreOutlined
  ArrowLeftOutlined: typeof ArrowLeftOutlined
  BellFilled: typeof BellFilled
  CalendarFilled: typeof CalendarFilled
  CalendarTwoTone: typeof CalendarTwoTone
  CloseCircleOutlined: typeof CloseCircleOutlined
  CloseOutlined: typeof CloseOutlined
  CheckCircleOutlined: typeof CheckCircleOutlined
  CheckCircleTwoTone: typeof CheckCircleTwoTone
  CheckCircleFilled: typeof CheckCircleFilled
  DeleteFilled: typeof DeleteFilled
  DownOutlined: typeof DownOutlined
  EditOutlined: typeof EditOutlined
  ExclamationCircleOutlined: typeof ExclamationCircleOutlined
  ExclamationCircleTwoTone: typeof ExclamationCircleTwoTone
  EllipsisOutlined: typeof EllipsisOutlined
  FundFilled: typeof FundFilled
  FileImageOutlined: typeof FileImageOutlined
  InfoCircleOutlined: typeof InfoCircleOutlined
  InfoCircleTwoTone: typeof InfoCircleTwoTone
  InfoCircleFilled: typeof InfoCircleFilled
  HomeFilled: typeof HomeFilled
  LeftOutlined: typeof LeftOutlined
  LoadingOutlined: typeof LoadingOutlined
  MailOutlined: typeof MailOutlined
  MinusCircleOutlined: typeof MinusCircleOutlined
  MinusCircleTwoTone: typeof MinusCircleTwoTone
  MoneyCollectFilled: typeof MoneyCollectFilled
  MoneyCollectTwoTone: typeof MoneyCollectTwoTone
  PayCircleFilled: typeof PayCircleFilled
  PlusOutlined: typeof PlusOutlined
  QuestionCircleTwoTone: typeof QuestionCircleTwoTone
  RightOutlined: typeof RightOutlined
  SearchOutlined: typeof SearchOutlined
  SettingFilled: typeof SettingFilled
  SettingOutlined: typeof SettingOutlined
  TagFilled: typeof TagFilled
  UpOutlined: typeof UpOutlined
  UploadOutlined: typeof UploadOutlined
  UserOutlined: typeof UserOutlined
  CopyOutlined: typeof CopyOutlined
  PropertySafetyOutlined: typeof PropertySafetyOutlined
}

export const Icon: IconType = {
  AccountBookFilled,
  AppstoreOutlined,
  ArrowLeftOutlined,
  BellFilled,
  CalendarFilled,
  CalendarTwoTone,
  CloseCircleOutlined,
  CloseOutlined,
  CheckCircleOutlined,
  CheckCircleTwoTone,
  CheckCircleFilled,
  DeleteFilled,
  DownOutlined,
  EditOutlined,
  EllipsisOutlined,
  ExclamationCircleOutlined,
  ExclamationCircleTwoTone,
  FundFilled,
  FileImageOutlined,
  InfoCircleOutlined,
  InfoCircleTwoTone,
  InfoCircleFilled,
  HomeFilled,
  LeftOutlined,
  LoadingOutlined,
  MailOutlined,
  MinusCircleOutlined,
  MinusCircleTwoTone,
  MoneyCollectFilled,
  MoneyCollectTwoTone,
  PayCircleFilled,
  PlusOutlined,
  QuestionCircleTwoTone,
  RightOutlined,
  SearchOutlined,
  SettingFilled,
  SettingOutlined,
  TagFilled,
  UpOutlined,
  UploadOutlined,
  UserOutlined,
  CopyOutlined,
  PropertySafetyOutlined,
  Icon: undefined,
}
